const dungeonTimeAttack = `

#### Dungeon Time Slots (UTC+1)
| **Dungeon**                      | **Time** |
|----------------------------------|-----------------|
| Ruins of Arid Moonlight 1       | Saturday 1pm - 3pm |
| Ruins of Arid Moonlight 2       | Sunday 1pm - 3pm |
| Lost Mines 1                    | Saturday 2pm - 4pm |
| Lost Mines 2                    | Sunday 2pm - 4pm |
| Crystal Valley 1                | Saturday 3pm - 5pm |
| Crystal Valley 2                | Sunday 3pm - 5pm |
| Palmir 1                         | Saturday 4pm - 6pm |
| Palmir 2                         | Sunday 4pm - 6pm |
| Sanctuary                        | Saturday 10pm - 12am |
| Temple of the Ancients           | Saturday 5pm - 7pm |
| Temple of the Lost Souls         | Sunday 6pm - 8pm |
| Temple of the Exile              | Saturday 7pm - 9pm |

---

### Guild vs. Guild Dungeon Battles

#### Dungeon Raids (Time Attacks)
- **Guilds compete** to complete dungeons in the fastest time.
- **Time attacks available Monday - Thursday**.
- **Friday**: Time Attacks close, and the **fastest guild is declared the winner**.
- The **winning guild/alliance** can challenge the current dungeon owner in a **Dungeon Siege** on the weekend.

#### How to Apply
- The **guild master** must register at the **Dungeon Stone** outside the dungeon.
- **Level Requirements**: The guild leader must be **within 20 levels** of the dungeon's recommended level.
- **Commands for Time Attacks:**
  - /screate TEAMNAME - Create a siege party.
  - /sinvite_gp guild/alliance member - Invite additional party leaders.
  - /pinvite PLAYERNAME - Form the raid teams.

#### Key Rules
- **Only guild/alliance members** of the applied team can participate.
- **Time Attack begins** when the Guild Master enters the dungeon.
- **Time Attack ends** when both bosses are defeated.
- **Players will NOT lose Lak, EXP, or gain immorality points.**
- **Max Participants per Dungeon:**
  - **Moonlight**: 8 players
  - **Lost Mines**: 16 players
  - **Crystal Valley**: 24 players
  - **Ruins of Palmir**: 32 players
  - **Sanctuary & Temples**: 16 players

### Dungeon Sieges (PvP)
- **Objective**: Control the **Dungeon Stone**.
- **Current dungeon owners defend**, the **winning raid team attacks**.
- Siege battles follow **the same raid commands**.
- The **guild master must be present** for the party creation.
- **Winning Conditions**:
  - Defenders: Destroy the **Attacker’s Dungeon Stone** to win.
  - Attackers: Capture the **Dungeon Core** and hold it.
  - If the **Dungeon Core is lost**, the teams **reset roles**.
  - The **final defender after 2 hours** wins the siege.

Prepare for battle and claim dominance over **dungeon territories**!`;

export default dungeonTimeAttack;
